import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import ServiceData from '../../fakeData/ServiceData';
import ServiceDetails from './ServiceDetails';
import './Services.css';

const Services = () => {
    return (
        <div id="service" className="services text-center">
          <h2 className="text-center"><span>SERVICES WE</span> PROVIDE</h2>
                <p>
                We move mountains to achieve our client’s objectives. Our passion for achievement <br></br>is what drives us and our customers alike.
                </p>
                <div className="separator">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
            <div className="row">
              
                <div className="col-md-12">
                    {
                        ServiceData.map(service=> (
                            <ServiceDetails key={service.id} service={service}/>
                     ))}

                </div>
            </div>
        </div>
    );
};

export default Services;